var map = {
	"./ali-ulvi.png": 9405,
	"./bilim-cocuk-kapak.png": 948,
	"./bilim-ve-teknik-kapak.png": 6147,
	"./map.png": 4912,
	"./marker.png": 9710,
	"./merakli-minik-kapak.png": 8971,
	"./success.png": 6155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9982;